<template>
  <div class="gc-list-log-wrap">
    <div class="search-wrap">
      <!-- <div class="left" @click="showPicker=true">
                请选择时间
            </div> -->
      <div class="right">
        <van-search v-model="keywords" placeholder="请输入搜索关键词"/>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        @cancel="showPicker = false"
        @confirm="confirmPicker"
      />
    </van-popup>

    <ul class="log-list-menu">
      <li class="item" v-for="(item, index) in logList" :key="index">
        <div class="title">
          <van-checkbox
            v-model="item.checked"
            @change="handleChange"
            icon-size="0.3rem"
          >{{ item.ProItem.Name }}
          </van-checkbox
          >
          <router-link
            tag="div"
            :to="{
              name: 'ProjectDetail',
              params: { sysno: item.ProItem.Sysno }
            }"
            class="more"
          >详细信息
          </router-link
          >
        </div>
        <div class="info-wrap">
          <div class="info-item">
            <span>内容：</span>
            <div class="info">
              {{ item.Remark }}
            </div>
          </div>
          <div class="info-item">
            <span>时间：</span>
            <div class="info">
              {{
                item.ProDate.substr(0, 10) + "至" + item.ProDate.substr(11, 10)
              }}
            </div>
          </div>
          <div class="info-item">
            <span>备注：</span>
            <textarea class="info beizhu" v-model="item.proContent"></textarea>
          </div>
        </div>
        <div class="jindu-wrap">
          <span>进度：</span>
          <van-slider
            class="jindu-slider"
            v-model="item.pValue"
            bar-height=".25rem"
            active-color="#D32F2F"
            inactive-color="#eee"
          >
            <template #button>
              <div class="custom-button">
                <span>{{ item.pValue }}%</span>
              </div>
            </template>
          </van-slider>
        </div>
      </li>
    </ul>
    <div class="log-bottom-wrap">
      <van-checkbox
        v-model="checkedAll"
        @click="handleChangeAll"
        icon-size="0.4rem"
      >全选
      </van-checkbox
      >
      <div class="submit-btn" @click="onSubmit">提 交</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      minDate: new Date(2020, 0, 1),
      currentDate: new Date(),
      showPicker: false,
      keywords: "",
      checkedAll: false,
      // logList: [{checked:false},{checked:false},{checked:false}]
      logList: []
    };
  },
  mounted() {
    this.WebGetProjectSimpleInfoLstLog();
  },
  watch: {
    keywords() {
      this.logList = [];
      this.WebGetProjectSimpleInfoLstLog();
    }
  },
  methods: {
    confirmPicker(e) {
      this.showPicker = false;
    },
    handleChange(e) {
      let checkedAll = this.logList.every(item => {
        return item["checked"];
      });
      this.checkedAll = checkedAll;
    },
    handleChangeAll(e) {
      if (this.checkedAll) {
        this.logList.map(item => {
          return (item["checked"] = true);
        });
      } else {
        this.logList.map(item => {
          return (item["checked"] = false);
        });
      }
    },
    // 日志列表
    WebGetProjectSimpleInfoLstLog() {
      let searchkey =
        this.$basecode.base64encode(this.$basecode.utf16to8(this.keywords)) ||
        "";
      let data = {
        UserId: localStorage.getItem("UserSysno"),
        StatusKey: "1", //0 未参与  1未完成  2审核中 4已完成
        DepSysno: localStorage.getItem("GovDepSysno"),
        SearchKey: searchkey
      };
      // console.log(data);
      this.$baseajax.normalJsonp(
        this.$base.baseProject + "/WebGetProjectSimpleInfoLstLog",
        data,
        res => {
          console.log("日志管理", res);
          res = res.WebGetProjectSimpleInfoLstLogResult;
          if (res.ResponseCode == 1) {
            if (res.ItemLst) {
              for (let item of res.ItemLst) {
                item.pValue =
                  item.ProRunStatus == "-1.00%"
                    ? 0
                    : Number(parseFloat(item.ProRunStatus).toFixed(0));
                item.checked = false;
              }
              this.logList = res.ItemLst;
            }
          }
        },
        err => {
        }
      );
    },
    onSubmit() {
      let ischecked = this.logList.some(item => {
        return item.checked;
      });
      if (!ischecked) {
        this.$toast("请先选择要提交的项");
        return;
      }
      let arr = [];
      for (let item of this.logList) {
        if (item.checked) {
          arr.push({
            ProSysno: item.ProItem.Sysno,
            ProRunStatus: item.pValue,
            proContent: item.proContent
          });
        }
      }
      // console.log(arr);
      this.WebSetUserWeekContentLog(arr);
    },
    // 提交日志
    WebSetUserWeekContentLog(arr) {
      let data = {
        UserSysno: localStorage.getItem("UserSysno"),
        item: arr
      };
      this.$baseajax.sliceRequest(
        this.$base.baseProject + "/WebSetUserWeekContentLog",
        data,
        res => {
          console.log(res);
          if (res.ResponseCode == 1) {
            this.$toast("提交成功");
          }
        },
        err => {
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/base.less";

.gc-list-log-wrap {
  padding-bottom: 1.3rem;
}

.search-wrap {
  margin: 0.28rem 0.28rem 0;
  padding: 0.18rem 0.25rem;
  background-color: #ffffff;
  box-shadow: 0rem 0.01rem 0.12rem 0rem rgba(26, 26, 26, 0.1);
  border-radius: 0.27rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    font-size: 0.33rem;
    color: #333333;
    padding-right: 0.25rem;
    margin-right: 0.25rem;
    border-right: 1px solid #c8c8c8;
  }

  .right {
    // width: 7rem;
    flex: 1;
    min-width: 0;
  }

  .van-search,
  .van-search .van-cell {
    padding: 0;
  }

  /deep/ .van-icon-search {
    color: #d1d1d1;
  }

  .van-search__content {
    background: #fff;
    padding-left: 0;
  }

  /deep/ .van-field__control {
    font-size: 0.33rem;
  }
}

.jindu-slider {
  margin-top: 0.3rem;
  opacity: 1;

  /deep/ .van-slider__button-wrapper {
    // margin-top: 0.5rem;
  }

  /deep/ .custom-button {
    position: relative;
    font-size: 0.28rem;
    color: #666666;
    width: 0.39rem;
    height: 0.39rem;
    border-radius: 100%;
    background-color: #D32F2F;
    box-shadow: 0rem 0.01rem 0.12rem 0rem rgba(26, 26, 26, 0.4);

    span {
      position: absolute;
      bottom: -0.65rem;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.log-list-menu {
  padding-left: 0.28rem;
  padding-right: 0.28rem;

  .item {
    margin-top: 0.28rem;
    padding: 0.48rem 0.26rem 1rem;
    background-color: #ffffff;
    box-shadow: 0rem 0rem 0.17rem 0rem rgba(211, 47, 47, 0.14);
    border-radius: 0.27rem;

    .title {
      font-size: 0.4rem;
      color: #333333;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .van-checkbox {
        max-width: 7rem;

        /deep/ .van-icon {
          font-size: 0.3rem;
        }
      }

      .more {
        font-size: 0.27rem;
        color: #D32F2F;

        &:after {
          display: inline-block;
          vertical-align: middle;
          content: "";
          width: 0.15rem;
          height: 0.15rem;
          border-top: 1px solid #ffb311;
          border-left: 1px solid #ffb311;
          transform: rotate(135deg);
        }
      }
    }

    .info-wrap {
      padding: 0.4rem 0.35rem;

      .info-item {
        margin-top: 0.08rem;
        display: flex;

        span {
          width: 1rem;
          flex: 0 0 1rem;
          font-size: 0.32rem;
          color: #666666;
        }

        .info {
          font-size: 0.3rem;
          color: #888888;

          &.beizhu {
            width: 100%;
            padding: 0.15rem;
            background-color: #f2f2f2;
            border-radius: 0.13rem;
            min-height: 1.7rem;
            resize: vertical;
          }
        }
      }
    }
  }
}

.jindu-wrap {
  padding: 0 0.35rem;
  font-size: 0.32rem;
  color: #666666;
}

.log-bottom-wrap {
  position: fixed;
  bottom: 1.33333rem;
  background: #fff;
  width: 100%;
  padding: 0.23rem 0.28rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.33rem;
  color: #666666;
  border-top: 1px solid #eee;

  .submit-btn {
    width: 2.12rem;
    height: 0.85rem;
    line-height: 0.85rem;
    background-color: #D32F2F;
    border-radius: 0.13rem;
    font-size: 0.4rem;
    color: #ffffff;
    text-align: center;

    &.disabled {
      background-color: #fedd95;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/manage/Log.vue